import Component from '../core/Component'
import { scrollToElement } from '../services/Scroll'

export default class FormOrderOcis extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            parts: []
        }
    }

    prepare() {
        this.parts = this.ref.parts.map(part => ({
            id: part.id,
            component: Component.getFromElement(part)
        }))
        this.parts.forEach(part => part.component.on('change', this.handlePartChange))
        this.render('')
    }

    destroy() {
        this.parts.forEach(part => part.component.destroy())
        this.parts = null
    }

    handlePartChange = ({ value, path = '', anchor = '' }) => {
        this.render(`${path}.${value}`)

        if (anchor) {
            const element = document.getElementById(anchor.substr(1))
            scrollToElement(element)
        }
    }

    render(path) {
        this.parts.forEach(part => part.component.update(path))
    }

}
